import {JumperPiece} from "./jumperPiece";
import {BISHOP_BLACK, BISHOP_WHITE} from "./svg";

export class Bishop extends JumperPiece {
    name = 'bishop';
    directions = [[-1, -1], [-1, +1], [+1, -1], [+1, +1]];

    svgBlack = BISHOP_BLACK;
    svgWhite = BISHOP_WHITE;

    getDirections() {
        return this.directions;
    }

    clone() {
        const result = new Bishop();
        super.clone(result);
        return result;
    }
}